import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/mnt/workspaces/front/wenkoo/bus-site/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/mnt/workspaces/front/wenkoo/bus-site/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/workspaces/front/wenkoo/bus-site/src/app/components/edu/AgentTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/workspaces/front/wenkoo/bus-site/src/app/components/edu/ChatInput.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/workspaces/front/wenkoo/bus-site/src/app/components/edu/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/workspaces/front/wenkoo/bus-site/src/app/components/huizhi/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/workspaces/front/wenkoo/bus-site/src/app/components/I18nBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/workspaces/front/wenkoo/bus-site/src/app/components/kexin/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/workspaces/front/wenkoo/bus-site/src/app/components/modal/AuthModals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/workspaces/front/wenkoo/bus-site/src/app/components/modal/ExpiredModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/workspaces/front/wenkoo/bus-site/src/app/components/modal/Login.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/workspaces/front/wenkoo/bus-site/src/app/components/modal/Register.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/workspaces/front/wenkoo/bus-site/src/app/components/StartBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/workspaces/front/wenkoo/bus-site/src/app/components/student/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/workspaces/front/wenkoo/bus-site/src/app/components/Xingmo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/workspaces/front/wenkoo/bus-site/src/app/components/xingmo/mobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/workspaces/front/wenkoo/bus-site/src/app/components/xingmo/pc.tsx");
